import { Box, useTheme } from "@mui/material";
import { styles } from "./styles/ContainerWrapper.styles";

export default function ContainerWrapper({ children }) {
    const theme = useTheme()
    return (
        <Box className="container-wrapper" sx={[theme.palette.mode !== "dark" && styles.container]}>
            {children}
        </Box>
    )
}